<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h6>Dashboard </h6>
          </div>

          <div class="card-body">
            <form [formGroup]="BarChartForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row" style="padding-right: 8px;">
                      <div class="col-md-12" style="border: groove;">
                        <div style="display: block;">
                          <h6>Service Requests Assigned To Me By Priority</h6>
                          <br>
                          <canvas id="myChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row" style="padding-left: 8px;">
                      <div class="col-md-12" style="border: groove;">
                        <div style="display: block;">
                          <h6>My Groups Service Requests By Priority</h6>
                          <br>
                          <canvas id="groupChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="clearfix"></div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row" style="padding-left: 8px;">
                      <div class="col-md-12" style="border: groove;">
                        <div style="display: block;" id="mychart">
                          <h6>My Service Requests By Priority</h6>
                          <br>
                          <canvas id="myServiceChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-danger">
            <h6>Dashboard </h6>
          </div>

          <div class="card-body">
            <form [formGroup]="BarChartForm">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row" style="padding-right: 8px;">
                      <div class="col-md-12" style="border: groove;">

                        <div style="display: block;">
                          <h6>Service Requests Assigned To Me By Priority</h6>
                          <br>
                          <canvas baseChart 
                                        [datasets]="barChartData"
                                        [labels]="barChartLabels"
                                        [options]="barChartOptions"
                                        [legend]="barChartLegend"
                                        [chartType]="barChartType">
                                      </canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row" style="padding-left: 8px;">
                      <div class="col-md-12" style="border: groove;">
                        <div style="display: block;">
                          <h6>My Groups Service Requests By Priority</h6>
                          <br>
                          <canvas baseChart [datasets]="GroupbarChartData" [labels]="barChartLabels"
                            [options]="barChartOptions" [legend]="GroupbarChartLegend" [chartType]="barChartType">
                          </canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="clearfix"></div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row" style="padding-left: 8px;">
                      <div class="col-md-12" style="border: groove;">
                        <div style="display: block;" id="mychart">
                          <h6>My Service Requests By Priority</h6>
                          <br>
                          <canvas baseChart [datasets]="MybarChartData" [labels]="barChartLabels"
                            [options]="barChartOptions" [legend]="MybarChartLegend" [chartType]="barChartType">
                          </canvas>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->